const features = [
  {
    icon: 'ri-timer-flash-fill',
    title: '60-Minute Response',
    desc: 'Our emergency crews are strategically positioned to reach your property within 60 minutes of your call, day or night.',
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'IICRC Certified',
    desc: 'All technicians hold current IICRC certifications in water damage restoration, mold remediation, and fire/smoke restoration.',
  },
  {
    icon: 'ri-microscope-fill',
    title: 'Advanced Technology',
    desc: 'We use thermal imaging, industrial-grade drying equipment, and air scrubbers to ensure thorough, lasting restoration.',
  },
  {
    icon: 'ri-file-list-3-fill',
    title: 'Insurance Assistance',
    desc: 'We work directly with all major insurance carriers and provide detailed documentation to streamline your claims process.',
  },
  {
    icon: 'ri-user-star-fill',
    title: 'Experienced Team',
    desc: 'With 15+ years in the industry and 5,000+ completed projects, our team brings unmatched expertise to every job.',
  },
  {
    icon: 'ri-medal-fill',
    title: 'Satisfaction Guaranteed',
    desc: 'We stand behind our work with a comprehensive satisfaction guarantee. Your property restored right — or we make it right.',
  },
];

export default function WhyUsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="text-[#DC2626] text-xs font-semibold uppercase tracking-widest">Why Choose Us</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] mt-2 mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Advanced Technology.<br />
              Certified Experts.<br />
              Guaranteed Results.
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              When disaster strikes, you need a team you can trust completely. Mitigation Restoration Services combines cutting-edge technology with deep expertise to deliver results that exceed expectations — every single time.
            </p>
            <div className="bg-gradient-to-br from-[#1E3A5F] to-[#0d2a47] rounded-2xl p-8 text-white">
              <p className="text-xs font-semibold uppercase tracking-widest text-white/60 mb-4">Our Promise</p>
              <blockquote className="text-lg font-medium leading-relaxed italic text-white/90">
                &ldquo;We restore more than properties — we restore peace of mind with every project we complete.&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 mt-6">
                <img
                  src="https://public.readdy.ai/ai/img_res/bcd4071bbf5746600aeadcd243768d39.jpg"
                  alt="CEO"
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <p className="font-semibold text-sm">James Mitchell</p>
                  <p className="text-white/60 text-xs">Founder & CEO, MRS</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {features.map((f) => (
              <div key={f.title} className="bg-[#F8F9FA] rounded-xl p-5 hover:bg-[#1E3A5F] group transition-colors duration-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#DC2626]/10 group-hover:bg-[#DC2626]/20 mb-3">
                  <i className={`${f.icon} text-[#DC2626] text-lg`}></i>
                </div>
                <h4 className="font-bold text-[#1E3A5F] group-hover:text-white text-sm mb-1.5 transition-colors">{f.title}</h4>
                <p className="text-gray-500 group-hover:text-white/70 text-xs leading-relaxed transition-colors">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
